<template>
  <div
    v-if="report"
    class="analysis-report-form"
  >
    <ul>
      <li>
        <h4>分析情報</h4>
        <div class="analysis m-4 p-3">
          <div>
            <img
              v-if="innerImage"
              :src="innerImage"
              :alt="innerTitle"
              width="100%"
            />
          </div>
          <div>
            <ul class="ml-5">
              <li>ASIN：{{ innerAsin }}</li>
              <li>商品名：{{ innerTitle }}</li>
              <li>点数：{{ innerRate }}</li>
              <li>バリエーション：{{ innerVariation }}</li>
              <li>期間：{{ innerDate }}</li>
              <li>
                分析対象のレビュー数：<a
                  href="#"
                  @click.stop.prevent="onClickDownload(innerId, false)"
                >{{ innerCount }}件</a>
              </li>
              <li>
                総レビュー数：<a
                  href="#"
                  @click.stop.prevent="onClickDownload(innerId, true)"
                >{{ innerAll }}件</a>
              </li>
            </ul>
          </div>
        </div>
      </li>
      <li
        v-for="(r, index) in innerReport"
        :key="index"
      >
        <h4 :class="index > 0 ? 'mt-8' : ''">
          {{ r.title }}
        </h4>
        <paragraph class="m-4 p-3 rounded-lg">{{ r.content }}</paragraph>
      </li>
    </ul>
  </div>
</template>

<script>
import Paragraph from '@/components/Paragraph'

export default {
  name: 'ReviewAnalysisReportForm',
  components: {
    Paragraph
  },
  props: {
    report: {
      type: Object,
      required: true
    }
  },
  emits: ['onClickDownload'],
  computed: {
    innerId: {
      get () {
        return (this.report) ? this.report.id : ''
      }
    },
    innerImage: {
      get () {
        return (this.report) ? this.report.image : ''
      }
    },
    innerAsin: {
      get () {
        return (this.report) ? this.report.asin : ''
      }
    },
    innerTitle: {
      get () {
        return (this.report) ? this.report.title : ''
      }
    },
    innerRate: {
      get () {
        return (this.report) ? this.report.rate : ''
      }
    },
    innerVariation: {
      get () {
        return (this.report) ? this.report.variation : ''
      }
    },
    innerDate: {
      get () {
        return (this.report) ? this.report.date : ''
      }
    },
    innerCount: {
      get () {
        return (this.report) ? this.report.count : ''
      }
    },
    innerAll: {
      get () {
        return (this.report) ? this.report.all : ''
      }
    },
    innerReport: {
      get () {
        return (this.report) ? this.report.gpt : []
      }
    }
  },
  methods: {
    onClickDownload (id, isAll) {
      this.$emit('onClickDownload', {id, isAll})
    }
  }
}
</script>

<style scoped>
.analysis-report-form p {
  background-color: #ddd;
}
div.analysis {
  display: grid;
  grid-template-columns: 200px 1fr;
}
div.analysis ul {
  list-style-position: inside;
  list-style-type: circle;
}
</style>
